/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  const customWishlistButtons = document.querySelectorAll('.swym_wishlist');

  const waitForElement = (selector, callback) => {
    const element = document.querySelector(selector);
    if (element) {
      callback(element);
    } else {
      setTimeout(() => {
        waitForElement(selector, callback);
      }, 100);
    }
  };

  waitForElement('#notepad-anchor-title', () => {
    customWishlistButtons.forEach((elem) => {
      elem.addEventListener('click', (e) => {
        document.querySelector('#notepad-anchor-title').click();
      });
    })
  });
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
